const createMemoryHistory = require("history").createMemoryHistory;
import {IOpsSdk} from "./types";

const createPluginHistory = (baseApi: IOpsSdk) => {
    const pluginHistory = createMemoryHistory();

    if (baseApi.portal.pluginUrl.get() !== '') {
        pluginHistory.push(baseApi.portal.pluginUrl.get());
    }

    pluginHistory.listen(e => {
        baseApi.portal.pluginUrl.set(e.pathname + e.search + e.hash);
    });

    return pluginHistory;
};

export default createPluginHistory;